import { cx } from "../tv";

const isMac = typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent);

/** Platform-aware key names: "Mod" becomes ⌘ on Apple devices and Ctrl elsewhere. */
export function keyLabel(combo: string) {
  return combo
    .split("+")
    .map((k) => (k === "Mod" ? (isMac ? "⌘" : "Ctrl") : k === "Shift" ? (isMac ? "⇧" : "Shift") : k === "Alt" ? (isMac ? "⌥" : "Alt") : k === "Enter" ? "↵" : k))
    .join(isMac ? "" : " ");
}

/** Keyboard hint in the mono face (DESIGN-RULES 6). */
export function Kbd({ children, tone = "default", className }: { children: string; tone?: "default" | "inverse"; className?: string }) {
  return (
    <kbd
      className={cx(
        "inline-flex h-5 min-w-5 items-center justify-center rounded-xs px-1 font-mono text-2xs font-medium leading-none",
        tone === "default" ? "bg-panel-solid text-fg-subtle shadow-[inset_0_0_0_1px_var(--border)]" : "bg-[color-mix(in_oklch,var(--panel-solid)_18%,transparent)] text-panel-solid",
        className,
      )}
    >
      {keyLabel(children)}
    </kbd>
  );
}
